module.exports = __webpack_public_path__ + "static/media/dog-itching.7215a9f3.gif";